import { doc, subCollection, type Timestamp } from "@doitintl/models-types";

export const AUTO_GENERATED_AWS_ACCOUNTS_DOC_KEY = "auto-generated-aws-accounts";
export const AWS_ACCOUNTS_COLLECTION_KEY = "awsAccounts";
export const AWS_ACCOUNT_COMMANDS_COLLECTION_KEY = "awsAccountCommands";
export const TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY = "twilioPhoneNumberUsageHistory";

export const AWS_ACCOUNTS_BATCH_COLLECTION_KEY = "awsAccountCommandBatches";

export enum AwsAccountCompletionStep {
  CREDENTIALS = "CREDENTIALS",
  ACCOUNT_DATA = "ACCOUNT_DATA",
  PAYMENT_INFORMATION = "PAYMENT_INFORMATION",
  IDENTITY_CONFIRMATION = "IDENTITY_CONFIRMATION",
  ADMIN_ROLES = "ADMIN_ROLES",
  MFA = "MFA",
  GENUINE_AWS_ACCOUNT_ID = "GENUINE_AWS_ACCOUNT_ID",
  ACCOUNT_ALIAS = "ACCOUNT_ALIAS",
  BILLING_INFO_ACCESS = "BILLING_INFO_ACCESS",
}

@subCollection(AWS_ACCOUNTS_COLLECTION_KEY)
export class AwsAccountModel {
  public static readonly FIREBASE_KEY = AWS_ACCOUNTS_COLLECTION_KEY;

  accountName!: string;

  genuineAwsAccountId!: string | null;

  email!: string;

  completeSteps!: AwsAccountCompletionStep[];

  phoneNumber!: string | null;

  creditCard!: string | null;

  blocked?: boolean;

  inOrganization?: boolean;

  identityVerificationComplete?: boolean;

  emailsUnsubscribed?: boolean;

  hasPlaceholderName?: boolean;
}

export enum AwsAccountCommandType {
  CREATE_AWS_ACCOUNT = "CREATE_AWS_ACCOUNT",
  UPDATE_AWS_ACCOUNT = "UPDATE_AWS_ACCOUNT",
}

export enum AwsAccountCommandStatus {
  SCHEDULED = "SCHEDULED",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  BLOCKED = "BLOCKED",
  COMPLETE = "COMPLETE",
}

export enum AwsAccountCommandBatchStatus {
  SCHEDULED = "SCHEDULED",
  RUNNING = "RUNNING",
  PAUSED = "PAUSED",
  CANCELLED = "CANCELLED",
  COMPLETE = "COMPLETE",
}

export type AwsAccountCommandCaptcha = {
  captchaImageURL: string;
  captchaSolution: string;
};

export type AwsAccountCommandParameterBrowser = "chrome" | "chromium" | "firefox" | "msedge";
export type AwsAccountCommandParameterTimezone =
  | "America/New_York"
  | "America/Los_Angeles"
  | "America/Chicago"
  | "America/Detroit";
export type AwsAccountCommandParameterProxy = "us-east-1" | "us-east-2" | "us-west-2" | "eu-central-1";

@subCollection(AWS_ACCOUNT_COMMANDS_COLLECTION_KEY)
export class AwsAccountCommand {
  public static readonly FIREBASE_KEY = AWS_ACCOUNT_COMMANDS_COLLECTION_KEY;

  accountId!: string;

  type!: AwsAccountCommandType;

  status!: AwsAccountCommandStatus;

  errorMessage!: string | null;

  errorOccurredAt!: Timestamp | null;

  captcha!: AwsAccountCommandCaptcha | null;

  timeCreated!: Timestamp;

  processingStartedAt!: Timestamp | null;

  retryCount!: number;

  parameters?: AwsAccountCommandParameters;

  updateParameters?: AwsAccountUpdateParameters;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  browserConfiguration?: any;

  exists?: boolean;

  batchID?: string;

  manual?: boolean;
}

@subCollection(AWS_ACCOUNTS_BATCH_COLLECTION_KEY)
export class AwsAccountCommandBatch {
  public static readonly FIREBASE_KEY = AWS_ACCOUNTS_BATCH_COLLECTION_KEY;

  batchSize!: number;

  successCount!: number;

  startTime!: Timestamp;

  endTime?: Timestamp;

  status!: AwsAccountCommandBatchStatus;

  timeCreated!: Timestamp;

  timeUpdated?: Timestamp;

  batchID?: string;
}

export class AwsAccountCommandParameters {
  useDefaultBrowserSettings?: boolean;

  browser?: AwsAccountCommandParameterBrowser;

  timezone?: AwsAccountCommandParameterTimezone;

  creditCardSuffix?: string;

  proxy?: AwsAccountCommandParameterProxy;
}

export class AwsAccountUpdateParameters {
  name?: string;

  email?: string;
}

@doc(AUTO_GENERATED_AWS_ACCOUNTS_DOC_KEY)
export class AutoGeneratedAwsAccountsDoc {
  subCollections?: {
    [AWS_ACCOUNTS_COLLECTION_KEY]: AwsAccountModel;
    [AWS_ACCOUNT_COMMANDS_COLLECTION_KEY]: AwsAccountCommand;
    [TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY]: TwilioPhoneNumberUsageHistory;
  };
}

@subCollection(TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY)
export class TwilioPhoneNumberUsageHistory {
  public static readonly FIREBASE_KEY = TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY;

  phoneNumber!: string;

  usedAt!: Timestamp[];

  awsAccountIds!: string[] | null;

  phonePIN!: string | null;

  batchID?: string;
}
